module.exports = __webpack_public_path__ + "assets/training-item-mobile-upload.f5a1850f.svg";